/**
 * A global namespace for `Tab` key.
 * e.which = 9 equivalent
 */
const keyTab = 'Tab';

export default keyTab;
